import { Col, Row } from 'reactstrap';
import { clx } from 'Utils';
import { Card } from 'Elements';
import styles from 'partials/card/subscription-card.module.scss';
import { FC } from 'react';

export const SkeletonCommissionGroup: FC = () => {
	// Inline skeleton style
	const skeletonStyle: React.CSSProperties = {
		minHeight: 20,
		width: '100px'
	};

	return (
		<Col>
			<Card className="h-100">
				<h6
					className={clx(
						styles.row,
						'd-flex align-items-center justify-content-between text-gray-3 fs-6 fw-400'
					)}>
					<span className={styles.rowLabel}>
						<span className="skeletonStyle" style={skeletonStyle} />
					</span>
					<div className="d-flex gap-2 align-items-center">
						<span className="skeletonStyle" style={skeletonStyle} />
					</div>
				</h6>
				<Row>
					<Col sm={12}>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
						<div
							className={clx(
								styles.row,
								'd-flex align-items-center justify-content-between'
							)}>
							<span className={styles.rowLabel}>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
							<span>
								<span
									className="skeletonStyle"
									style={skeletonStyle}
								/>
							</span>
						</div>
					</Col>
				</Row>
			</Card>
		</Col>
	);
};
